<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div>
      {{ $t("description") }}
      <br />
      <br />
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-8">
          <div class="alert alert-primary" role="alert" v-if="alertMessage">
            {{ $t(alertMessage) }}
          </div>
          <small class="text-uppercase font-weight-bold">{{ $t("gamename") }}</small>
          <base-input
            maxLength="50"
            ref="gamename"
            id="input-gamename"
            v-model="form.gameName"
            v-bind:placeholder="$t('entername')"
            v-on:keyup.native.enter="onSubmit"
          />
          <base-button type="primary" :disabled="!form.gameName.length" v-on:click="onSubmit()">{{
            $t("submit")
          }}</base-button>
          <br />
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { changeGameName } from "../../services/APIService";

export default {
  components: { DefaultLayout },
  data: function() {
    return {
      form: {
        gameName: ""
      },
      alertMessage: null,
      scenarios: [],
      games: [],
      gameCode: null,
      id: null
    };
  },
  mounted() {},
  async created() {
    this.gameCode = this.$route.params.gamecode;
    this.id = this.$route.params.id;
  },
  methods: {
    onSubmit() {
      changeGameName(this.id, this.gameCode, this.form.gameName)
        .then(() => {
          this.$router.push("/admin/games");
        })
        .catch(error => {
          this.alertMessage = "errorsaving";
        });
    }
  }
};
</script>

<i18n>
{
  "en": {
    "description": "Please give a name for the simulation you have bought. The name will be shown to players when they join.",
    "entername": "* Name of the simulation",
    "submit": "Save",
    "gamename": "Name of the simulation",
    "errorsaving": "Error saving changes"
  },
  "fi": {
    "description": "Anna nimi ostamallesi simulaatiolle. Nimi näytetään pelaajille kun he liittyvät mukaan.",
    "entername": "* Simulaation nimi",
    "submit": "Tallenna",
    "gamename": "Simulaation nimi",
    "errorsaving": "Muutosten tallentaminen epäonnistui"
  },
  "sv": {
    "description": "Vänligen döp simuleringen du har köpt. Namnet kommer att visas för spelarna när de loggar in.",
    "entername": "* Simuleringens namn",
    "submit": "Spara",
    "gamename": "Simuleringens namn",
    "errorsaving": "Fel när ändringarna sparades"
  },
  "de": {
    "description": "Bitte geben Sie einen Namen für die Simulation an, die Sie gekauft haben. Der Name wird den Spielern angezeigt, wenn sie sich anmelden.",
    "entername": "* Name der Simulation",
    "submit": "Speichern",
    "gamename": "Name der Simulation",
    "errorsaving": "Fehler beim Speichern der Änderungen"
  },
  "ko": {
    "description": "구입한 시뮬레이션의 이름을 입력해주십시오. 이름은 모든 참여자에게 공개됩니다.",
    "entername": "* 시뮬레이션 이름",
    "submit": "저장",
    "gamename": "시뮬레이션 이름",
    "errorsaving": "Error saving changes"
  }
}
</i18n>
